// extracted by mini-css-extract-plugin
module.exports = {"refreshWrapper":"style_refreshWrapper__1OylL"};